export interface IVDLBannerTitleProps {
  title: string;
}

export const VDLBannerTitle = ({ title }: IVDLBannerTitleProps) => {
  return (
    <h1 className="md:text-3xl text-2xl font-bold text-white">{title}</h1>
  );
};
